import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="w-full bg-navy-950 py-14 sm:py-20" data-id="element-350" data-mp="3mh2adt3b3cf2">
      <div className="mx-auto w-full max-w-4xl px-5" data-id="element-351" data-mp="3mfhd3vplxfdi">
        <p className="text-[0.7rem] font-bold uppercase tracking-[0.16em] text-cyan-bright" data-id="element-352" data-mp="3r7sez43wrb8p">
          What physicians say
        </p>
        <h2 className="mt-3 font-display text-[1.7rem] font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-353" data-mp="y288zucibs">
          Consultations that stopped starting from zero
        </h2>

        <div className="mt-8 space-y-4" data-id="element-354" data-mp="92fethe1i1vq">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="rounded-3xl border border-white/10 bg-navy-900 p-5 sm:p-6" data-id="element-355" data-mp="dznwlgva03wg">
              <div className="flex items-center gap-4" data-id="element-356" data-mp="2fs3rmbmqsa7d">
                <img src={testimonial.image} alt={testimonial.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-brand-500/50" loading="lazy" data-id="element-357" data-mp="2fslz64euuaul" />
                <figcaption data-id="element-358" data-mp="1iu7vicb3e27q">
                  <p className="font-display text-base font-extrabold text-white" data-id="element-359" data-mp="1iv9ausz55av9">
                    {testimonial.name}
                  </p>
                  <p className="text-[0.8rem] font-medium text-slate-400" data-id="element-360" data-mp="2bjeufcegktti">
                    {testimonial.role}
                  </p>
                  <div className="mt-1 flex gap-0.5" aria-label="5 out of 5" data-id="element-361" data-mp="26lddax0lf4ko">
                    {Array.from({
                  length: 5
                }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-362" data-mp="22kjqk6yvzvtd" data-mpi={index} />)}
                  </div>
                </figcaption>
              </div>
              <blockquote className="mt-4 flex gap-3 text-[0.95rem] leading-relaxed text-slate-300" data-id="element-363" data-mp="m6tikp4ncneg">
                <QuoteIcon className="mt-1 h-4 w-4 shrink-0 text-brand-500" aria-hidden="true" data-id="element-364" data-mp="njt7264gzf9f" />
                <p data-id="element-365" data-mp="ejwis5lzsiew">{testimonial.quote}</p>
              </blockquote>
            </figure>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-366" data-mp="ikyg2gwcmke8">
          <CTAButton label="I want the same structure in my consultations" note="Immediate access · 7-day guarantee" data-id="element-367" data-mp="4veirqljefcb" />
        </div>
      </div>
    </section>;
}